import React, { useState, useEffect } from 'react';
import { Box, Button, Modal, TextField, Typography, Grid, Divider, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { updatePassivo } from '../../../services/passivosService';
import { TIPO_CHOICES, CATEGORIA_CHOICES } from '../../../types/passivos';

interface EditModalPassivosProps {
  isOpen: boolean;
  onRequestClose: () => void;
  rowData?: any;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: '1200px',
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
};

const EditModalPassivos: React.FC<EditModalPassivosProps> = ({ isOpen, onRequestClose, rowData }) => {
  const [formData, setFormData] = useState(rowData || {});

  useEffect(() => {
    if (rowData) setFormData(rowData);
  }, [rowData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (e: SelectChangeEvent, field: string) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await updatePassivo(formData.id, formData);
      onRequestClose();
    } catch (error) {
      console.error('Erro ao atualizar o passivo:', error);
    }
  };

  return (
    <Modal open={isOpen} onClose={onRequestClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2">Editar Passivo</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">Informações do Passivo</Typography>
            <Divider sx={{ mb: 2 }} />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Descrição do Passivo"
              name="descricao"
              value={formData.descricao || ''}
              onChange={handleChange}
              margin="normal"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Conta</InputLabel>
              <Select
                value={formData.conta || ''}
                onChange={(e) => handleSelectChange(e, 'conta')}
                label="Conta"
              >
                {CATEGORIA_CHOICES.map((choice) => (
                  <MenuItem key={choice} value={choice}>{choice}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Tipo</InputLabel>
              <Select
                value={formData.tipo || 'OUTRO'}
                onChange={(e) => handleSelectChange(e, 'tipo')}
                label="Tipo"
              >
                {TIPO_CHOICES.map((choice) => (
                  <MenuItem key={choice.value} value={choice.value}>{choice.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Salvar Alterações
          </Button>
          <Button variant="outlined" color="error" onClick={onRequestClose} sx={{ ml: 2 }}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditModalPassivos;
